function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "5.27230853%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#9DD4FC",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#628AFF",
  offset: "100%"
})), React.createElement("circle", {
  id: "path-2",
  cx: 21.5333333,
  cy: 17,
  r: 9.06666667
}), React.createElement("circle", {
  id: "path-3",
  cx: 12.4666667,
  cy: 17,
  r: 9.06666667
}));

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "url(#linearGradient-1)",
  cx: 17,
  cy: 17,
  r: 17
});

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  stroke: "#FFF",
  strokeWidth: 1.5,
  xlinkHref: "#path-2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("use", {
  stroke: "#FFF",
  strokeWidth: 1.5,
  xlinkHref: "#path-3"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "35px",
    height: "34px",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, React.createElement("g", {
    strokeWidth: 1,
    fill: "none"
  }, React.createElement("g", {
    id: "Icon-Explorations",
    transform: "translate(-328.000000, -254.000000)"
  }, React.createElement("g", {
    transform: "translate(328.256662, 254.000000)"
  }, _ref2, React.createElement("g", null, React.createElement("use", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    style: {
      "mixBlendMode": "soft-light"
    },
    xlinkHref: "#path-2"
  }), _ref3), React.createElement("g", null, React.createElement("use", {
    fill: "#D8D8D8",
    fillRule: "evenodd",
    style: {
      "mixBlendMode": "soft-light"
    },
    xlinkHref: "#path-3"
  }), _ref4)))));
};

export default __webpack_public_path__ + "static/media/bling_dei.c7185164.svg";
export { SvgComponent as ReactComponent };